// import appsetting from '../public/appSetting'
import { HubConnectionBuilder } from '@microsoft/signalr'
import moment from 'moment-jalaali'
// const URL = appsetting.ApiUrl
var URL = ''
const pn = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
const en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
const Adad = ['Mande', 'Mablagh', 'GhabelBardasht', 'mablagh', 'Bedeh', 'Bestan', 'MablaghSharj', 'bedeh', 'bestan', 'mabEnteghal', 'mabPardaxtShodeGhest', 'mandeGhest', 'mande', 'ghabelBardasht']
const mabalegh = ['Mande', 'Mablagh', 'GhabelBardasht', 'mablagh', 'Bedeh', 'Bestan', 'MablaghSharj', 'HodudGheymat', 'Mab', 'bedeh', 'bestan', 'mabEnteghal', 'mabPardaxtShodeGhest', 'mandeGhest', 'mande', 'ghabelBardasht', 'MabVarizi', 'mablaghGhestVam', 'SumBedeh', 'SumBestan']
let ConnectionTicketHub = null
let ConnectionChatHub = null
const GlobalPlugin = {
  install(Vue) {
    Vue.prototype.URL = ''
    Vue.prototype.$GetData_Header = function (InnerData) {
      var axios = require('axios')
      var config = {
        method: 'Get',
        // url: Vue.prototype.URL + InnerData.Action + '/' + InnerData.ArryfildValue.Id,
        url: this.$cookies.get('URL') + InnerData.Action + '/' + InnerData.ArryfildValue.Id,
        // headers: {
        //   Authorization: 'Bearer ' + InnerData.Token,
        //   'Content-Type': 'application/json',

        // },
        headers: {
          Authorization: 'Bearer ' + this.$session.get('Token'),
          'Content-Type': 'application/json',
        },
      }
      return axios(config).then((response) => response.data)
    }
    Vue.prototype.$GetAppsettings = function () {
      'Appsettings', this.$cookies.get('URL')

      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSetting.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((response) => {
        Vue.prototype.URL = response.data.ApiUrl
        this.$cookies.set('URL', response.data.ApiUrl)
        // console.log(Vue.prototype.URL)
      })
    }
    Vue.prototype.$GetData_Body = function (InnerData) {
      var axios = require('axios')
      var data = JSON.stringify(InnerData.ArryfildValue)
      var config = {
        method: 'Get',
        url: this.$cookies.get('URL') + InnerData.Action,
        data: data,
        headers: {
          Authorization: 'Bearer ' + InnerData.Token,
          'Content-Type': 'application/json',
        },
      }
      return axios(config).then((response) => response.data)
    }
    Vue.prototype.$SendSmsAmadeha = function () {
      var AxiosGet = { ArryfildValue: '', Method: 'Get', Action: 'SendSmsOnWcf', Token: this.$session.get('Token') }
      this.$GetData_Body(AxiosGet).then((data) => {
        if (data == 'Ok') {
          this.$mySweetDefaultTost('ارسال موفق', 'پیامک برای عضو شما ارسال گردید ', 'success', 2000)
        }
      })
    }

    Vue.prototype.$PostData = function (InnerData) {
      var axios = require('axios')
      var data = JSON.stringify(InnerData.ArryfildValue)
      var config = {
        method: InnerData.Method,
        url: this.$cookies.get('URL') + InnerData.Action,
        headers: {
          Authorization: 'Bearer ' + this.$session.get('Token'),
          'Content-Type': 'application/json',
        },
        data: data,
      }
      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          console.log(error)
          console.log('error', config)
          if (error.response.status === 401) {
            this.$session.destroy()
            this.$router.push({ name: 'Login' })
          } else {
            throw error
          }
        })
    }

    Vue.prototype.$PostData_new = function (method, url, data, fromForm) {
      var axios = require('axios')
      var config = {
        method: method,
        url: this.$cookies.get('URL') + url,
        headers: {
          Authorization: 'Bearer ' + this.$session.get('Token'),
          'Content-Type': 'application/json',
        },
      }
      if ((data != null) & (data != undefined)) {
        config.data = JSON.stringify(data)
      }
      if (fromForm == true) {
        config.headers = {
          Authorization: 'Bearer ' + this.$session.get('Token'),
          'Content-Type': 'multipart/form-data',
        }
        config.data = data
      }

      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          console.error('error', error)
          if (error.response.status === 401) {
            this.$session.destroy()
            this.$router.push({ name: 'Login' })
          } else {
            throw error
          }
        })
    }

    Vue.prototype.$PostFormData = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require('axios')
      var data = InnerData.ArryfildValue
      var config = {
        method: InnerData.Method,
        url: this.$cookies.get('URL') + InnerData.Action,
        headers: {
          Authorization: 'Bearer ' + this.$session.get('Token'),
          'Content-Type': 'multipart/form-data',
        },
        data: data,
      }
      return axios(config).then((response) => response.data)
    }

    Vue.prototype.$mySweetDefault = function (title, text, icon, timer) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        position: 'center',
        timer: timer,
        showConfirmButton: false,
        showCancelButton: false,
      })
    }
    //#region Sweet Plugin
    Vue.prototype.$mySweetDefaultTost = function (title, text, icon, timer) {
      this.$swal({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: timer,
        icon: icon,
        title: title,
        text: text,
        timerProgressBar: true,
      })
    }

    Vue.prototype.$SweetQustion = function (title, text, icon, confirmButtonText, cancelButtonText, node, fun1, fun2) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: '#1fad1f',
        cancelButtonColor: '#ad291f',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      }).then((result) => {
        if (result.isConfirmed) {
          if (node != null) {
            fun1(node)
          } else {
            fun1()
          }
        } else {
          fun2()
        }
      })
    }

    Vue.prototype.$SweetInput = function (title, text, icon, confirmButtonText, cancelButtonText, node, fun1, fun2) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        input: "text",
        showLoaderOnConfirm: true,
        showCancelButton: true,
        confirmButtonColor: '#1fad1f',
        cancelButtonColor: '#ad291f',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        preConfirm: async (login) => {
          try {
            if (login.trim().length>0) {
              node['inputValue']=login       
              return login;
            }
            else{
              node['inputValue']=null       
              return login;
              this.$mySweetDefaultTost('خطا در مقدار ورودی', ' مقدار وردی نمیتواند خالی باشد ', 'error', 2000)
            }     
            
          } catch (error) {
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          if (node != null) {
            fun1(node)
          } else {
            fun1()
          }
        } else {
          fun2()
        }
      })
    }

    //#endregion Sweet Plugin
    //#region GetDataDefultGrid
    Vue.prototype.$GetDataDefultGrid = function (InnerData) {
      console.log('😎 ~ install ~ InnerData:', InnerData)
      var axios = require('axios')
      var data = JSON.stringify(InnerData.ArryfildValue)
      var config = {
        method: InnerData.Method,
        url: this.$cookies.get('URL') + InnerData.Action,
        headers: {
          Authorization: 'Bearer ' + InnerData.Token,
          'Content-Type': 'application/json',
        },
        data: data,
      }
      return axios(config).then((response) => response.data)
    }
    //#endregion
    //#endregion
    //#region خواندن ستون های جداول
    Vue.prototype.$GetColumns = function (InnerData) {
      InnerData.ArryfildValue.UserId = this.$session.get('UserInfo').tblUserId
      var axios = require('axios')
      var data = JSON.stringify(InnerData.ArryfildValue)
      var config = {
        method: InnerData.Method,
        url: this.$cookies.get('URL') + InnerData.Action + '/Index',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }
      return axios(config).then((response) => response.data)
    }
    Vue.prototype.$myAxoisGridColumns = function (InnerData, IsAction, IsCustomCheckBox) {
      InnerData.ArryfildValue.UserId = this.$session.get('UserInfo').tblUserId
      var axios = require('axios')
      var data = JSON.stringify(InnerData.ArryfildValue)

      var config = {
        method: InnerData.Method,
        url: this.$cookies.get('URL') + InnerData.Action + '/Index',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      }
      axios(config)
        .then((response) => {
          let info
          let List = []
          for (let index = 0; index < response.data.length; index++) {
            info = response.data[index]
            List.push(info)
          }
          if (IsAction) {
            List.push({
              label: 'عملیات ها',
              name: 'id',
              slot_name: 'action-slot',
              sort: false,
            })
          }
          if (IsCustomCheckBox) {
            List.push({
              label: 'عملیات ها',
              name: 'id',
              slot_name: 'Select-slot',
              sort: false,
            })
          }

          this.$store.dispatch('SetCoolGrid', List)
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
          //console.log(this.List)
        })
        .then(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    //#endregion
    Vue.prototype.$ExportUrl = function () {
      return URL
    }
    ;(Vue.prototype.$CusCode = function () {
      return this.$session.get('SetupInfo').cusCode
    }),
      (Vue.prototype.$ValidForm = function (frm) {
        return this.$required(frm) && this.$ValidPass(frm) && this.$requiredCodeMeli(frm)
      })
    Vue.prototype.$ValidPass = function (frm) {
      var currform = document.getElementById(frm)
      var textboxPass = currform.getElementsByClassName('required-Pass')
      // var textboxPassConfirm = currform.getElementsByClassName('required-Pass-Confirm')
      let minPassLength = this.$session.get('SetupInfo').minPasswordLength

      for (let index = 0; index < textboxPass.length; index++) {
        var txtpass = textboxPass[index].value
        var length = txtpass.length

        let hasLowerCase = txtpass.match(/[a-z]/)?.length > 0 ? true : false
        let hasUpperCase = txtpass.match(/[A-Z]/)?.length > 0 ? true : false
        if (length < minPassLength) {
          this.$mySweetDefaultTost('', 'حداقل طول کلمه عبور باید برابر با ' + minPassLength + ' باشد', 'error', 2000)
          return false
        } else if ((hasLowerCase == false) | (hasUpperCase == false)) {
          this.$mySweetDefaultTost('', 'کلمه عبور باید شامل حروف کوچک و بزرگ انگلیسی باشد', 'error', 2000)
          return false
        } else if (txtpass.match(/[0-9]/)?.length > 0 == false) {
          this.$mySweetDefaultTost('', 'کلمه عبور باید دارای اعداد باشد', 'error', 2000)
          return false
        } else {
          return true
        }

        // if (length >= 4) {
        //   if (txtpass.match(/[a-z]/) && txtpass.match(/[A-Z]/)) {
        //     if (txtpass.match(/[0-9]/)) {
        //       console.log('true');
        //     } else {
        //       this.$mySweetDefaultTost('کلمه عبور باید دارای اعداد باشد', 'خطا', 'error', 2000)
        //       return false
        //     }
        //   } else {
        //     this.$mySweetDefaultTost('کلمه عبور باید شامل حروف کوچک و بزرگ انگلیسی باشد', 'خطا', 'error', 2000)
        //     return false
        //   }
        // } else {
        //   this.$mySweetDefaultTost('تعداد ارقام کلمه عبور جدید باید حداقل 4 حرف باشد', '', 'error', 2000)
        //   return false
        // }
      }
      return true
    }
    Vue.prototype.$requiredCodeMeli = function (frm) {
      var currform = document.getElementById(frm)
      var textboxCodeMeli = currform.getElementsByClassName('required-CodeMeli')
      for (let index = 0; index < textboxCodeMeli.length; index++) {
        if (textboxCodeMeli[index].value.trim() == '') {
          // alert("");
          // console.log('Error', textboxCodeMeli[index])
          textboxCodeMeli[index].classList.add('wronginput')
          this.$mySweetDefaultTost('خطا', 'کد ملی باید 10 رقم باشد', 'error', 2000)
          return true
        } else {
          var allDigitEqual = ['0000000000', '1111111111', '2222222222', '3333333333', '4444444444', '5555555555', '6666666666', '7777777777', '8888888888', '9999999999']
          var txtCodeMeli = []
          txtCodeMeli = String(textboxCodeMeli[index].value)
          if (allDigitEqual.find((element) => element == txtCodeMeli) > 0) {
            textboxCodeMeli[index].classList.add('wronginput')
            this.$mySweetDefaultTost('خطا', 'کد ملی صحیح نمیباشد ، تمام اعداد یکسان وارد شده است !', 'error', 2000)
            return false
          }
          var chArray = textboxCodeMeli[index].value.split('')
          var num0 = chArray[0] * 10
          var num2 = chArray[1] * 9
          var num3 = chArray[2] * 8
          var num4 = chArray[3] * 7
          var num5 = chArray[4] * 6
          var num6 = chArray[5] * 5
          var num7 = chArray[6] * 4
          var num8 = chArray[7] * 3
          var num9 = chArray[8] * 2
          var a = chArray[9]
          var b = num0 + num2 + num3 + num4 + num5 + num6 + num7 + num8 + num9
          var c = b % 11
          var b_ret = (c < 2 && a == c) || (c >= 2 && 11 - c == a)
          if (b_ret == false) {
            textboxCodeMeli[index].classList.add('wronginput')
            this.$mySweetDefaultTost('خطا', 'کد ملی صحیح نمی باشد', 'error', 2000)
            return false
          } else {
            textboxCodeMeli[index].classList.remove('wronginput')
          }
        }
      }
      return true
    }
    Vue.prototype.$required = function (frm) {
      var currform = document.getElementById(frm)
      var textbox = currform.getElementsByClassName('required')
      for (let index = 0; index < textbox.length; index++) {
        if (textbox[index].tagName == 'SELECT') {
          if (textbox[index].value != -1) {
            textbox[index].classList.remove('wronginput')
          } else {
            textbox[index].classList.add('wronginput')
            textbox[index].focus()
            // console.log(textbox[index])
            this.$mySweetDefaultTost('ورودی نا معتبر', 'فیلد مشخص شده الزامی می باشد ', 'error', 1200)
            return false
          }
        } else {
          let value = textbox[index].value.replace(/\s/g, '')
          if (!textbox[index].value || value == '') {
            textbox[index].classList.add('wronginput')
            textbox[index].focus()

            this.$mySweetDefaultTost('ورودی نا معتبر', 'فیلد مشخص شده الزامی می باشد ', 'error', 1200)
            return false
          } else {
            textbox[index].classList.remove('wronginput')
          }
        }
      }
      return true
    }
    Vue.prototype.$PassProgress = function (frm) {
      var currform = document.getElementById(frm)
      var textboxPass = currform.getElementsByClassName('required-Pass')
      var txtpass = textboxPass[0].value
      var length = txtpass.length
      var strength = 0
      if (length >= 6) {
        strength = +60
      }
      if (length == 1) {
        strength = 10
      }
      if (length == 2) {
        strength = 20
      }
      if (length == 3) {
        strength = 30
      }
      if (length == 4) {
        strength = 40
      }
      if (length == 5) {
        strength = 50
      }
      if (txtpass.match(/[a-z]/)) {
        strength = strength + 15
      }
      if (txtpass.match(/[A-Z]/)) {
        strength = strength + 15
      }
      if (txtpass.match(/[0-9]/)) {
        strength = strength + 10
      }
      //------Color Change------
      if (strength <= 25) {
        currform.querySelector('#progress-progress').style.backgroundColor = '#e50839'
      }
      if (strength <= 50 && strength > 25) {
        currform.querySelector('#progress-progress').style.backgroundColor = '#d9c709'
      }
      if (strength < 95 && strength > 50) {
        currform.querySelector('#progress-progress').style.backgroundColor = '#e4862c'
      }
      if (strength >= 95) {
        currform.querySelector('#progress-progress').style.backgroundColor = '#67b221'
      }

      currform.querySelector('.progress-bar > div').style.width = strength + '%'
      // currform.querySelector(".progress-bar > div").textContent = strength+"%";
    }
    Vue.prototype.$ValidNumber = function (e, length, IsNumber) {
      if (IsNumber) {
        if (e.key != 'Enter') {
          let Val = e.target.value.replace(/,/g, '').replace(/\./g, '')
          if (Val.length + 1 > length) {
            this.$mySweetDefaultTost(' محدویت کارکتر', ' حداکثر طول متن' + length + ' کارکتر می باشد ', 'warning', 2000)
            e.preventDefault()
          }
        } else {
          // console.log('else')
          let char = String.fromCharCode(e.keyCode)
          char = this.$b_ToPersianNumber(char)
          if (/^[0-9]+$/.test(char) || e.key == 'Enter' || e.key == '.') {
            e.target.value = e.target.value.replace(/\./g, '')
            return true
          } else {
            this.$mySweetDefaultTost('خطا', 'فقط اعداد مجاز است', 'error', 2000)
            e.preventDefault()
          }
        }
      } else {
        if (e.key != 'Enter') {
          let Val = e.target.value.replace(/,/g, '').replace(/\./g, '')
          if (Val.length + 1 > length) {
            this.$mySweetDefaultTost(' محدویت کارکتر', ' حداکثر طول متن' + length + ' کارکتر می باشد ', 'warning', 2000)
            e.preventDefault()
          }
        }
        let char = String.fromCharCode(e.keyCode)
        char = this.$b_ToPersianNumber(char)
        if (/^[0-9]+$/.test(char) || e.key == 'Enter') return true
        else if (e.key == '.') {
          return true
        } else {
          this.$mySweetDefaultTost('خطا', 'فقط اعداد مجاز است', 'error', 2000)
          e.preventDefault()
        }
      }
    }
    Vue.prototype.$Validengilsh = function (e, length) {
      if (e.target.value.length + 1 > length) {
        this.$mySweetDefaultTost(' محدودیت کارکتر', ' حداکثر طول متن' + length + ' کارکتر می باشد ', 'warning', 2000)
        e.preventDefault()
      }
      let char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z0-9]+$/.test(char)) return true
      else {
        this.$mySweetDefaultTost('خطا', 'فقط حروف لاتین مجاز است', 'error', 2000)
        e.preventDefault()
      }
    }
    Vue.prototype.$b_ToPersianNumber = function (num) {
      var char = num
      for (var i = 0; i < 10; i++) {
        char = char.replace(pn[i], en[i])
      }
      return char
    }
    Vue.prototype.$ValidLenght = function (e, length) {
      if (e.target.value.length + 1 > length) {
        this.$mySweetDefaultTost(' محدویت کارکتر', ' حداکثر طول متن' + length + ' کارکتر می باشد ', 'warning', 2000)
        e.preventDefault()
      }
    }
    Vue.prototype.$mySweetPost = function (title, text, icon, confirmButtonText, cancelButtonText) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: '#21AE8C',
        cancelButtonColor: '#FD5F00',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.state.renderComponentGrid = false
          this.$store.state.renderComponent = false
          this.$emit('Success', result.isConfirmed)
          this.$emit('Success', true)

          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
            this.$store.state.renderComponent = true
          })
        } else {
          document.getElementById('btnCancel').click()
          this.$store.state.renderComponentGrid = false
          this.$store.state.renderComponent = false

          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
            this.$store.state.renderComponent = true
          })
        }
      })
    }
    Vue.prototype.$getLocalIP = function () {
      return new Promise(function (resolve, reject) {
        var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection
        if (!RTCPeerConnection) {
          reject('Your browser does not support this API')
        }

        var rtc = new RTCPeerConnection({ iceServers: [] })
        var addrs = {}
        addrs['0.0.0.0'] = false

        function grepSDP(sdp) {
          var finalIP = ''
          sdp.split('\r\n').forEach(function (line) {
            if (~line.indexOf('a=candidate')) {
              let parts = line.split(' '),
                addr = parts[4],
                type = parts[7]
              if (type === 'host') {
                finalIP = addr
              }
            } else if (~line.indexOf('c=')) {
              let parts = line.split(' '),
                addr = parts[2]
              finalIP = addr
            }
          })
          return finalIP
        }

        if (window.mozRTCPeerConnection) {
          rtc.createDataChannel('', { reliable: false })
        }

        rtc.onicecandidate = function (evt) {
          if (evt.candidate) {
            var addr = grepSDP('a=' + evt.candidate.candidate)
            resolve(addr)
          }
        }
        rtc.createOffer(
          function (offerDesc) {
            rtc.setLocalDescription(offerDesc)
          },
          function (e) {
            console.warn('offer failed', e)
          }
        )
      })
    }
    Vue.prototype.$DeleteData = function (InnerData, Sweet) {
      var IdDelete = InnerData.ArryfildValue.id
      this.$swal({
        title: Sweet[0],
        text: Sweet[1],
        icon: Sweet[2],
        position: 'center-center',
        showConfirmButton: true,
        timer: Sweet[3],
        showCancelButton: true,
        confirmButtonColor: '#FD5F00',
        cancelButtonColor: '#1A86D0',
        confirmButtonText: 'حذف',
        cancelButtonText: 'انصراف',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$mySweetDefaultTost(false, '... درحال بارگزاری اطلاعات', false, false)
          var axios = require('axios')
          var config = {
            method: InnerData.Method,
            url: this.$cookies.get('URL') + InnerData.Action + '/' + IdDelete,
            headers: {
              Authorization: 'Bearer ' + InnerData.Token,
              'Content-Type': 'application/json',
            },
          }
          return axios(config).then((data) => {
            // console.log('1', data)
            // console.log('2', data.data)
            data.data
          })
        }
      })
    }
    Vue.prototype.$DeleteDatapropmise = function (InnerData, Sweet) {
      return new Promise((success, fail) => {
        var IdDelete = InnerData.ArryfildValue.id

        this.$swal({
          title: Sweet[0],
          text: Sweet[1],
          icon: Sweet[2],
          position: 'center-center',
          showConfirmButton: true,
          timer: Sweet[3],
          showCancelButton: true,
          confirmButtonColor: '#FD5F00',
          cancelButtonColor: '#1A86D0',
          confirmButtonText: 'حذف',
          cancelButtonText: 'انصراف',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$mySweetDefaultTost(false, '... درحال بارگزاری اطلاعات', false, false)
            var axios = require('axios')
            var config = {
              method: InnerData.Method,
              url: Vue.prototype.URL + InnerData.Action + '/' + IdDelete,
              headers: {
                Authorization: 'Bearer ' + InnerData.Token,
                'Content-Type': 'application/json',
              },
            }
            axios(config).then((data) => {
              if (data.data.status == 'Ok' || data.status == 200) {
                this.$SetLog(null, 1)
                this.$mySweetDefaultTost('حذف موفق', 'عملیات حذف اطلاعات با موفقیت انجام شد', 'success', 3000)
                if (this.$route.name == 'azainfo') {
                  this.$router.go(-1)
                }
                success(true)
                // if (refreshMethod) {
                //   refreshMethod();
                // }
                // return true;
              } else {
                if (data.data.eNum == '2601') {
                  this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                  fail(500)
                } else if (data.data.eNum == '547') {
                  this.$mySweetDefault('توجه ...', 'به دلیل وابستگی سایر اطلاعات امکان حذف این رکورد وجود ندارد! ', 'error', 3000)
                  fail(500)
                } else {
                  this.$mySweetDefault(
                    'خطایی رخ داده است',
                    'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید' + data.data.msg,

                    'error',
                    3000
                  )
                  fail(500)
                }
                // return false;
              }
            })
          } else {
            fail(55)
          }
        })
      })
    }
    //#region ثبت لاگ و مقایسه دیتا قدیم و جدید
    Vue.prototype.$SetLog = function (NewData, IsDelete, IsGrid, CustomFormId, CustomFormName) {
      let DataAddLogInformation = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'UserLogInformation/b_AddRow',
        Token: this.$session.get('Token'),
      }
      if (IsGrid == 1) {
        let OldData = JSON.parse(this.$store.state.OldDataForLog)
        var listLogRiz = []
        for (let k of Object.keys(NewData && OldData)) {
          if (OldData[k] != NewData[k]) {
            let LogRiz = { Id: 0, TblBnpCashLogId: 0, FieldName: null, FieldCaption: '', OldValue: '', NewValue: '' }
            LogRiz.FieldName = k
            LogRiz.FieldCaption = k
            LogRiz.OldValue = OldData[k] == null ? '' : OldData[k]
            LogRiz.NewValue = NewData[k] == null ? '' : NewData[k]
            listLogRiz.push(LogRiz)
          }
        }
        let object = this.$store.state.objectLogInformation
        object.UserId = this.$session.get('UserInfo').tblUserId
        object.UserNameFamily = this.$session.get('UserInfo').namFam

        if (CustomFormId) {
          object.FormId = CustomFormId
        } else {
          object.FormId = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
        }
        object.tblShobeId = this.$session.get('UserInfo').tblShobeId
        object.FkId = NewData.Id
        object.IsDelete = IsDelete
        object.TblBnpCashLogRiz = listLogRiz

        for (let index = 0; index < this.$session.get('Menu').length; index++) {
          const element = this.$session.get('Menu')[index]
          if (element.RouteName == object.FormId) {
            object.FormName = element.label
          } else if (CustomFormName) {
            object.FormName = CustomFormName
          }
        }
        this.$getLocalIP().then((res) => {
          object.IpAddress = res
        })
        DataAddLogInformation.ArryfildValue = object
        this.$PostData(DataAddLogInformation).then(() => {})
      } else {
        if (IsDelete == 0) {
          let OldData = JSON.parse(this.$store.state.OldDataForLog)
          let AllElements = document.getElementById(String(this.$route.name)).getElementsByTagName('small')
          AllElements = Array.prototype.slice.call(AllElements)
          var listLogRiz = []
          for (let k of Object.keys(NewData && OldData)) {
            if (OldData[k] != NewData[k] && NewData[k] != OldData[k] && typeof NewData[k] != 'object') {
              let LogRiz = { Id: 0, TblBnpCashLogId: 0, FieldName: null, FieldCaption: '', OldValue: '', NewValue: '' }

              AllElements.forEach((element) => {
                if (element.id.substring(3) == k) {
                  var Lable = element.innerHTML
                  LogRiz.FieldCaption = Lable
                }
              })
              LogRiz.FieldName = k
              LogRiz.OldValue = OldData[k] == null ? '' : OldData[k]
              LogRiz.NewValue = NewData[k] == null ? '' : NewData[k]
              listLogRiz.push(LogRiz)
            }
          }
          //#region ثبت رویداد های سیستم
          let object = this.$store.state.objectLogInformation
          object.UserId = this.$session.get('UserInfo').tblUserId
          object.UserNameFamily = this.$session.get('UserInfo').namFam
          if (CustomFormId) {
            object.FormId = CustomFormId
          } else {
            object.FormId = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
          }
          object.tblShobeId = this.$session.get('UserInfo').tblShobeId
          object.FkId = NewData.Id
          object.IsDelete = IsDelete
          object.TblBnpCashLogRiz = listLogRiz

          for (let index = 0; index < this.$session.get('Menu').length; index++) {
            const element = this.$session.get('Menu')[index]
            if (element.RouteName == object.FormId) {
              object.FormName = element.label
            } else if (CustomFormName) {
              object.FormName = CustomFormName
            }
          }

          this.$getLocalIP().then((res) => {
            object.IpAddress = res
          })
          DataAddLogInformation.ArryfildValue = object
          this.$PostData(DataAddLogInformation).then(() => {})
          //#endregion  ثبت رویداد های سیستم
        } else {
          let OldData = JSON.parse(this.$store.state.OldDataForLog)
          let listLogRiz = []
          for (let k of Object.keys(OldData)) {
            if (typeof OldData[k] != 'object') {
              let LogRiz = { Id: 0, TblBnpCashLogId: 0, FieldName: null, FieldCaption: 'همه فیلد ها', OldValue: '', NewValue: '' }

              LogRiz.FieldName = k
              LogRiz.OldValue = OldData[k] == null ? '' : OldData[k]
              LogRiz.NewValue = 'حذف گردید'
              listLogRiz.push(LogRiz)
            }
          }
          //#region ثبت رویداد های سیستم
          let object = this.$store.state.objectLogInformation
          object.UserId = this.$session.get('UserInfo').tblUserId
          object.UserNameFamily = this.$session.get('UserInfo').namFam

          object.FormId = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
          object.tblShobeId = this.$session.get('UserInfo').tblShobeId
          object.FkId = OldData.Id
          object.IsDelete = IsDelete
          object.TblBnpCashLogRiz = listLogRiz

          for (let index = 0; index < this.$session.get('Menu').length; index++) {
            const element = this.$session.get('Menu')[index]
            if (element.RouteName == object.FormId) {
              object.FormName = element.label
            } else if (CustomFormName) {
              object.FormName = CustomFormName
            }
          }
          this.$getLocalIP().then((res) => {
            object.IpAddress = res
          })

          DataAddLogInformation.ArryfildValue = object
          this.$PostData(DataAddLogInformation).then(() => {})
          //#endregion  ثبت رویداد های سیستم
        }
      }
    }
    //#endregion
    //#region ثبت لاگ تیکت
    Vue.prototype.$SetTicketLog = function (dataLog) {
      let DataAddLog = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Ticket/AddTicketLog',
        Token: this.$session.get('Token'),
      }
      DataAddLog.ArryfildValue = dataLog
      this.$PostData(DataAddLog).then(() => {})
    }
    //#endregion
    Vue.prototype.$ValidPersian = function (e, length) {
      if (e.target.value.length + 1 > length) {
        this.$mySweetDefaultTost(' محدودیت کارکتر', ' حداکثر طول متن' + length + ' کارکتر می باشد ', 'warning', 2000)
        e.preventDefault()
      }
      let char = String.fromCharCode(e.keyCode)
      if (!/^[A-Za-z]+$/.test(char)) return true
      else {
        this.$mySweetDefaultTost('خطا', 'فقط حروف فارسی مجاز است', 'error', 2000)
        e.preventDefault()
      }
    }
    Vue.prototype.$FindData = function (InnerData) {
      var axios = require('axios')
      var config = {
        method: InnerData.Method,
        url: Vue.prototype.URL + InnerData.Action + '/' + InnerData.ArryfildValue.id,
        headers: {
          Authorization: 'Bearer ' + InnerData.Token,
          'Content-Type': 'application/json',
        },
      }
      return axios(config).then((response) => response.data)
    }
    Vue.prototype.$PutData_Body = function (InnerData) {
      // var idEdit = this.$store.state.idForUpdate;
      var model = InnerData.ArryfildValue
      var axios = require('axios')
      var config = {
        method: InnerData.Method,
        url: Vue.prototype.URL + InnerData.Action,
        headers: {
          Authorization: 'Bearer ' + InnerData.Token,
        },
        data: model,
      }
      return axios(config).then((response) => response.data)
    }

    Vue.prototype.$GetJalaliDateTime = function () {
      var Dt = moment().format('jYYYY/jMM/jDD H:mm')
      return Dt
    }
    Vue.prototype.$GetJalaliDate = function () {
      var D = moment().format('jYYYY/jMM/jDD')
      return D
    }
    ;(Vue.prototype.$PutCommatoInput_New = function (ev) {
      let element = ev.srcElement
      let value = element.value
      value = element.value.replaceAll(',', '')

      value = value.toString()
      if ((value[0] == 0) & (value.length > 1)) {
        value = value.slice(1, value.length)
      }

      var commas = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      element.value = commas
      return commas
    }),
      (Vue.prototype.$PutCommatoInput = function () {
        var mabalegh = document.getElementsByClassName('3ragham')
        mabalegh = Array.prototype.slice.call(mabalegh)
        mabalegh.forEach((element) => {
          while (element.value.charAt(0) === '0' && element.value.length > 1) {
            element.value = element.value.substring(1)
          }
          element.value = element.value.replace(/,/g, '').replace(/\./g, '')
          // element.value = element.value..replace(/\./g,' ')
          element.value = Vue.prototype.$Comma3ragham(element.value)
        })
      })
    Vue.prototype.$Comma3ragham = function (Number) {
      if (Number == 0 || Number == '0') {
        return Number
      }
      Number += ''
      Number = Number.replace(/,/g, '').replace(/\./g, '')
      var x = Number.split('.')
      var y = x[0]
      var z = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
      return y + z
    }
    Vue.prototype.$DotInMablagh = function (e, Lenght) {
      if (e.key == '.') {
        if (Lenght - e.target.value.replace(/,/g, '').replace(/\./g, '').length >= 3) {
          // console.log(e.target.value, e.target.value.replace(/\./g, ''));
          e.target.value = e.target.value.replace(/\./g, '')
          e.target.value = e.target.value.replace(/,/g, '')
          e.target.value = e.target.value + '000'
          this.$PutCommatoInput_New(e)
        } else if (Lenght - e.target.value.replace(/,/g, '').replace(/\./g, '').length < 3) {
          let A = Lenght
          let B = e.target.value.replace(/,/g, '').replace(/\./g, '').length
          let C = A - B
          for (let index = 0; index < C; index++) {
            e.target.value = e.target.value.replace(/\./g, '')
            e.target.value = e.target.value.replace(/,/g, '')
            e.target.value = e.target.value + '0'
            this.$PutCommatoInput_New(e)
          }
        }
      }
    }
    Vue.prototype.$FormatMablaghGrid = function (rows) {
      rows.forEach((row) => {
        for (let [key, value] of Object.entries(row)) {
          for (let index = 0; index < mabalegh.length; index++) {
            const filter = mabalegh[index]
            if (key.toString().includes(filter)) {
              row[key] = this.$Comma3ragham(value)
            }
          }
        }
      })
      return rows
    }
    Vue.prototype.$GetSignalR = async function () {
      try {
        const hubConnection = new HubConnectionBuilder()
          .withUrl(this.$cookies.get('URL') + 'TicketHub', { accessTokenFactory: () => this.$session.get('Token') })
          .withAutomaticReconnect()
          .build()

        // .configureLogging(LogLevel.None)  + logLevel Import microsoft signalR

        hubConnection.serverTimeoutInMilliseconds = 129600000
        await hubConnection
          .start()
          .then(() => {})
          .catch((err) => {
            // console.error("اتصال تیکت هاب برقرار نشد", err)
          })

        ConnectionTicketHub = hubConnection

        // hubConnection.onclose(function (err) {
        //   console.error("اتصال تیکت هاب قطع شد", err)
        //   setTimeout(() => {
        //     hubConnection.start()
        //   }, 5000);
        // })

        // hubConnection.onreconnecting(function (error) {
        //   // alert("اتصال شما در حال برقرای است لطفا صبر کنید")
        //   console.error(error)
        // })

        return hubConnection
      } catch (error) {
        console.log(error)
      }
    }
    Vue.prototype.$GetSignalRChat = async function () {
      const hubConnection = new HubConnectionBuilder()
        .withUrl(this.$cookies.get('URL') + 'ChatRoomHub', { accessTokenFactory: () => this.$session.get('Token') })
        .withAutomaticReconnect()
        .build()
      hubConnection.serverTimeoutInMilliseconds = 129600000
      await hubConnection.start().catch((err) => {
        // console.error("اتصال چت روم هاب برقرار نشد", err)
      })

      ConnectionChatHub = hubConnection
      // hubConnection.onclose(function (err) {
      //   console.error("اتصال چت روم هاب قطع شد", err)
      //   setTimeout(() => {
      //     hubConnection.start()
      //   }, 5000);
      // })

      // hubConnection.onreconnecting(function (error) {
      //   // alert("اتصال شما در حال برقرای است لطفا صبر کنید")
      //   console.error(error)
      // })

      return hubConnection
    }
    Vue.prototype.$MessengerHub = async function () {
      const hubConnection = new HubConnectionBuilder()
        .withUrl(this.$cookies.get('URL') + 'MessengerHub', { accessTokenFactory: () => this.$session.get('Token') })
        .withAutomaticReconnect()
        .build()
      hubConnection.serverTimeoutInMilliseconds = 129600000
      await hubConnection.start().catch((err) => {
        // console.error("اتصال مسنجر هاب برقرار نشد", err)
      })
      ConnectionChatHub = hubConnection

      // hubConnection.onclose(function (err) {
      //   console.error("اتصال مسنجر هاب قطع شد", err)
      //   setTimeout(() => {
      //     hubConnection.start()
      //   }, 5000);
      // })

      return hubConnection
    }
    Vue.prototype.$GetAccessUser = function () {
      var menu = this.$session.get('Menu')
      var IdMenu = menu.find((x) => x.RouteName == this.$route.name).id
      this.$store.state.elmAccess = menu.filter((x) => x.ParentId == IdMenu)
    }
    Vue.prototype.$IsAccess = function (elmId) {
      let IsExist = false
      this.$store.state.elmAccess.forEach((element) => {
        if (element.ControlName == elmId) {
          if (element.isMojaz == 1) {
            IsExist = true
          }
        }
      })

      return IsExist
    }
    Vue.prototype.$CalcBedehiCustomer = function (TblCustomerId) {
      let DataAxios_GetRemember = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Deposit/GetRemember',
        Token: this.$session.get('Token'),
      }
      let Data = {}
      DataAxios_GetRemember.ArryfildValue = { tblCustomerId: TblCustomerId }
      return this.$PostData(DataAxios_GetRemember)
      // .then(data=>{
      //   Data=data[0];
      // }).finally(()=>{
      //   return Data
      // })
    }
    Vue.prototype.$RemoveAlert = function (message) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      return new Promise(function (resolve, reject) {
        swalWithBootstrapButtons
          .fire({
            title: 'اطمینان دارید؟',
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'بله',
            cancelButtonText: 'لغو',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
      })
    }
    Vue.prototype.$DecryptionWithCryptoJS = function (cipher) {
      var CryptoJS = require('crypto-js')
      const key = CryptoJS.enc.Utf8.parse('7061737323313233')
      const iv1 = CryptoJS.enc.Utf8.parse('7061737323313233')
      const plainText = CryptoJS.AES.decrypt(cipher, key, {
        keySize: 16,
        iv: iv1,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      return plainText.toString(CryptoJS.enc.Utf8)
    }
    Vue.prototype.$Encryption = function (strToEnc) {
      if (!strToEnc) return ''
      if (strToEnc == '') return ''
      var CryptoJS = require('crypto-js')
      var key = CryptoJS.enc.Utf8.parse('7061737323313233')
      var iv = CryptoJS.enc.Utf8.parse('7061737323313233')
      var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(strToEnc), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      return encrypted.toString()
    }
    Vue.prototype.$Gateway = function () {
      var DataAxiosRow = { ArryfildValue: {} }
      DataAxiosRow.Action = 'Gateway/GetGateway'
      DataAxiosRow.Method = 'post'
      return this.$PostData(DataAxiosRow).then((data) => data)
    }
    Vue.prototype.$OsName = function () {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    }
    Vue.prototype.$GetipClient = function () {
      try {
        var axios = require('axios')

        var config = {
          method: 'get',
          url: 'https://ip-api.ir/info/myip',
          headers: {},
        }

        return axios(config)
      } catch (error) {}
    }
    Vue.prototype.$GetCustomerDetail = function (tblCustomerId) {
      var DataAxiosGetCustomer = { Action: 'TblCustomerCrm/GetFullCustomer', Method: 'Post', ArryfildValue: { id: tblCustomerId, Usergrp: this.$session.get('UserInfo').tblUserId } }
      return this.$PostData(DataAxiosGetCustomer).then((data) => data)
    }
    ;(Vue.prototype.$getDaysArray = function (start, end) {
      for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt))
      }
      arr = arr.map((v) => v.toISOString().split('T')[0].replace(/-/g, '/'))
      return arr
    }),
      (Vue.prototype.$IsCustomer = function () {
        return Vue.prototype.$session.get('CustomerInfo') != undefined && Vue.prototype.$session.get('CustomerInfo').Id > 0 ? true : false
      })
    Vue.prototype.$b_InvertCode = function (b_code, b_jodakonande) {
      if (b_jodakonande != '') {
        var b_CodeSplit = b_code.split(b_jodakonande)
        var b_InvCode = ''
        for (let index = 0; index < b_CodeSplit.length; index++) {
          b_InvCode += b_CodeSplit[b_CodeSplit.length - 1 - index] + b_jodakonande
        }
        return b_InvCode.slice(0, -1)
      } else {
        return b_code
      }
    }
    Vue.prototype.$Get_FormatShomareOzv = function () {
      const format = this.$session.get('UserInfo').codeShobe.trim() + this.$session.get('b_SetShomareOzvMask').trim().substring(3, 4).replaceAll('0', '#') + this.$session.get('b_SetShomareOzvMask').trim().substring(4).replaceAll('0', '#') // 111-000001

      return format
    }
    Vue.prototype.$Get_FormatVcode = function () {
      const formatVcode =
        this.$session.get('UserInfo').codeShobe.trim() +
        this.$session.get('b_SetVCodeMask').trim().substring(3, 4).replaceAll('0', '#') +
        this.$session.get('b_SetVCodeMask').trim().substring(4, 6).replaceAll('0', '#') +
        this.$session.get('b_SetVCodeMask').trim().substring(6, 7).replaceAll('0', '#') +
        this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#') //111-01-000001
      return formatVcode
    }
    ;(Vue.prototype.$CheckupLengthCodeMeli = function (event) {
      if (event.target.value.length > event.target.maxLength) {
        this.$store.state.TarifKarbaran.Data[0].UserCodeMeli = event.target.value.slice(0, event.target.maxLength)
      }
    }),
      (Vue.prototype.$NewGridColumns = function (InnerData, IsAction, IsCustomCheckBox, IsSort, IsRow) {
        var axios = require('axios')
        var data = JSON.stringify(InnerData.ArryfildValue)

        var config = {
          method: InnerData.Method,
          url: this.$cookies.get('URL') + InnerData.Action + '/Index',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        }
        let List = []
        this.$store.state.renderComponent = false
        axios(config)
          .then((response) => {
            let info
            if (IsRow) {
              List.push({
                label: 'ردیف',
                name: 'row',
                slot_name: 'action-slot2',
                sort: false,
              })
            }
            for (let index = 0; index < response.data.length; index++) {
              info = response.data[index]
              IsSort == true ? (info['sort'] = true) : (info['sort'] = false)
              List.push(info)
            }
            if (this.$route.name == 'SanadRizNew') {
              List.push({
                id: '1010',
                name: 'FishNoRahgiri',
                visibility: true,
                width: 181,
                indexCol: 0,
                label: 'ش فیش/ رهگیری',
              })
            }
            if (IsAction) {
              List.push({
                label: 'عملیات ها',
                name: 'id',
                slot_name: 'action-slot',
                sort: false,
              })
            }
            if (IsCustomCheckBox) {
              List.push({
                label: 'عملیات ها',
                name: 'id',
                slot_name: 'Select-slot',
                sort: false,
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })
        return List
      })
    Vue.prototype.$AddZero = function (e) {
      // در جدول ثبت سند فیلدهای غیر عددی نباید صفر شوند
      if (Adad.includes(e.target.name)) {
        if (e.target.value != '0' && e.target.value == '') {
          e.target.value = '0'
        }
      }
    }
    Vue.prototype.$RemoveZero = function (e) {
      if (e.target.value == '0' && e.target.value != '') {
        e.target.value = ''
      }
    }
    Vue.prototype.$uploadInImg = function (e, imgId, Idtext) {
      const input = e.target
      var reader = new FileReader()
      reader.onload = function (e) {
        document.getElementById(imgId).setAttribute('src', e.target.result)
        // document.getElementById(Idtext).value = e.target.result
      }
      reader.readAsDataURL(input.files[0])
    }
    Vue.prototype.$DataURIToBlob = function (dataURI) {
      // console.log("***", dataURI);
      const splitDataURI = dataURI.split(',')
      const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
      const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
      const ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i)
      return new Blob([ia], { type: mimeString })
    }
    Vue.prototype.$FindeCustomerById = function (Route, params, Isactive, e) {
      const routeData = this.$router.resolve({ name: Route })
      this.$store.commit('myCustomerId', params)
      Isactive == false ? this.$store.commit('myactiveTab', false) : this.$store.commit('myactiveTab', Isactive)
      if (e && e.which == 2) window.open(routeData.href, '_blank')
      else this.$router.push({ name: Route })
    }
    Vue.prototype.$SubtractTime = function (StartTime, EndTIme) {
      var st = StartTime.split(':')
      st = parseInt(st[0]) * 60 + parseInt(st[1])

      var et = EndTIme.split(':')
      et = parseInt(et[0]) * 60 + parseInt(et[1])

      var minutes = et - st
      var restult = Math.floor(minutes / 60) + ':' + (minutes % 60)
      return restult
    }
    Vue.prototype.$CalcDayBetween2Date = function (StartDate, EndDate) {
      if (StartDate == '' || EndDate == '') {
        return 'تاریخ ها به درستی وارد نشده'
      } else {
        const startDate = moment(StartDate, 'jYYYY/jMM/jDD')
        const endDate = moment(EndDate, 'jYYYY/jMM/jDD')
        return endDate.diff(startDate, 'days')
      }
    }
    Vue.prototype.$SumTime = function (StartTime, EndTime) {
      var st = StartTime.split(':')
      st = parseInt(st[0]) * 60 + parseInt(st[1])

      var et = EndTime.split(':')
      et = parseInt(et[0]) * 60 + parseInt(et[1])

      var minutes = et + st
      var restult = Math.floor(minutes / 60) + ':' + (minutes % 60)
      return restult
    }

    Vue.prototype.$CompareTime = function (StartTime, EndTime) {
      var st = StartTime.split(':')
      st = parseInt(st[0]) * 60 + parseInt(st[1])

      var et = EndTime.split(':')
      et = parseInt(et[0]) * 60 + parseInt(et[1])
      var minutes = et - st
      var restult = Math.floor(minutes / 60) + ':' + (Math.floor(minutes) % 60)
      return et > st ? restult : 0
    }
    //تبدیل تایم به تایم استاندارد
    Vue.prototype.$ConvertTimeToStandardTime = function (time) {
      let parts = time.split(':') // split the string by colon
      let hour = parts[0].padStart(2, '0') // pad the hour with zero if needed
      let minute = parts[1].padStart(2, '0') // pad the minute with zero if needed
      let second = '00' // assume the second is zero
      return hour + ':' + minute + ':' + second // concatenate the parts
    }
   
    Vue.prototype.$GetFirstAndLastDayOfMonth = function (sd) {
      let Date = { SDate: '', EDate: '' }
      let a = sd && sd != null ? sd : this.$GetJalaliDate().split('/')
      a[2] = '01'
      Date.SDate = a[0] + '/' + a[1] + '/' + a[2]
      const currentDate = moment()
      const lastDayOfMonth = currentDate.endOf('jMonth')
      Date.EDate = lastDayOfMonth.format('jYYYY/jMM/jDD')
      return Date
    }

    Vue.prototype.$FindTableNameOnAutomationCartabl = function (tblFormAutomationId) {
      return new Promise((success, fail) => {
        var SendData = { Action: 'Cartabl/FindTableName', Method: 'POST', ArryfildValue: null }
        var formData = new FormData()
        formData.append('TblFormAutomationId', tblFormAutomationId)
        SendData.ArryfildValue = formData
        this.$PostFormData(SendData).then((result) => {
          if (result != null) {
            success(result.infoDes.split('tbl')[1])
          } else {
            fail(result)
          }
        })
      })
    }

    // جمع دو ساعت 10:30+20:30=40:00
    // 1
    Vue.prototype.$addTimes = function (time1, time2) {
      // تبدیل زمان به میلی‌ثانیه
      var time1Millis = this.$timeToMillis(time1)
      var time2Millis = this.$timeToMillis(time2)

      // جمع دو زمان
      var sumMillis = time1Millis + time2Millis

      // تبدیل میلی‌ثانیه به ساعت و دقیقه
      var sumHours = Math.floor(sumMillis / 3600000)
      var sumMinutes = Math.floor((sumMillis % 3600000) / 60000)

      // فرمت‌بندی ساعت و دقیقه به صورت "HH:mm"
      var resultTime = this.$pad(sumHours) + ':' + this.$pad(sumMinutes)

      return resultTime
    }

    // تبدیل زمان به میلی‌ثانیه
    //2
    Vue.prototype.$timeToMillis = function (time) {
      var parts = time.split(':')
      var hours = parseInt(parts[0], 10)
      var minutes = parseInt(parts[1], 10)
      return hours * 3600000 + minutes * 60000
    }

    // افزودن صفر به عددی که کمتر از 10 است
    //3
    Vue.prototype.$pad = function (number) {
      return (number < 10 ? '0' : '') + number
    }
  },
}

export default GlobalPlugin
